import(/* webpackMode: "eager" */ "/apps/jenkins_home/jobs/sxm-web-de-cms/jobs/sxm-web-de-cms-app/jobs/PROD-BUILD/workspace@2/cdn/de-sxm-www/src/app/[...slug]/not-found.tsx");
